export function DateConverter(date) {
    let formattedDate = new Date(date);
    let hours = formattedDate.getHours();
    let minutes = formattedDate.getMinutes();
    let ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0'+minutes : minutes;
    let ranTime = hours + ':' + minutes + ' ' + ampm;
    console.log(ranTime);
}

export const getDataFromSession = (key) => {
    try {
        return JSON.parse(sessionStorage.getItem(key)) || []
    } catch (error) {
        return false;
    }
}

// for converting the normal date to US date
export const dateConvertToUSTime = (date) => {
    let newDate = ''
    if (date) {
        if (date.includes('-')) {
            let dateArr = date.split('-')
            newDate = `${dateArr[1]}/${dateArr[2]}/${dateArr[0]}`
            return newDate;
        } else {
            let dateArr = date.split('/')
            let month = dateArr[0] < 10 ? `0${dateArr[0]}` : dateArr[0]
            let day = dateArr[1] < 10 ? `0${dateArr[1]}` : dateArr[1]
            return `${month}/${day}/${dateArr[2]}`
        }
    }
}

// function to format number to phone type
export const formatPhoneNumber = (phone) => {
  const cleaned = ('' + phone).replace(/\D/g, '');
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return '(' + match[1] + ') ' + match[2] + '-' + match[3];
  }
  return phone; // Return original if not 10 digits
}

// Utility function to parse and format dates
// export const formatToMMDDYYYY = (dateString) => {
//   if (!dateString) return '';

//   let date;
//   try {
//     // Attempt to parse various formats
//     date = new Date(dateString);

//     // Check for invalid date (e.g., "Invalid Date")
//     if (isNaN(date.getTime())) {
//       // Fallback for 'm/dd/yyyy' if new Date() fails for single digit month
//       const parts = String(dateString).match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
//       if (parts) {
//         date = new Date(parts[3], parts[1] - 1, parts[2]);
//       } else {
//         return dateString; // Return original if parsing fails completely
//       }
//     }
//   } catch (error) {
//     console.error("Error parsing date:", dateString, error);
//     return dateString; // Return original string if an error occurs
//   }

//   // Ensure date is valid after all parsing attempts
//   if (isNaN(date.getTime())) {
//     return dateString; // Return original if still invalid
//   }

//   const month = (date.getMonth() + 1).toString().padStart(2, '0');
//   const day = date.getDate().toString().padStart(2, '0');
//   const year = date.getFullYear();

//   return `${month}/${day}/${year}`;
// };


export const formatToMMDDYYYY = (dateString, timezone = 'America/Los_Angeles') => {
  if (!dateString) return '';
  let date;
  try {
    date = new Date(dateString);
    // Check for invalid date (e.g., "Invalid Date")
    if (isNaN(date.getTime())) {
      const parts = String(dateString).match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
      if (parts) {
        date = new Date(parts[3], parts[1] - 1, parts[2]);
      } else {
        return dateString; // Return original if parsing fails completely
      }
    }
  } catch (error) {
    console.error("Error parsing date:", dateString, error);
    return dateString;
  }
  // Normalize the date to the specified timezone
  const options = { timeZone: timezone, year: 'numeric', month: '2-digit', day: '2-digit' };
  const localDateString = date.toLocaleString('en-US', options);
  // Split the date string into parts
  const [month, day, year] = localDateString.split('/');
  return `${month}/${day}/${year}`;
};
